import { api } from "../lib/apiClient";

export async function signupRequest(payload) {
  const { data } = await api.post("/auth/signup", payload);
  return data;
}

export async function passwordRequest(payload) {
  const { data } = await api.post("/auth/password", payload);
  return data;
}

export async function loginRequest(credentials) {
  const { data } = await api.post("/auth/login", credentials);
  return data;
}

export async function reinitPasswordRequest(payload) {
  const { data } = await api.post("/auth/reinit-password", payload);
  return data;
}

export async function logoutRequest() {
  await api.post("/auth/logout");
}

export async function getMeRequest() {
  const { data } = await api.get("/auth/me");
  return data;
}
